import React from 'react';
import PageHero from '../components/PageHero';
import Testimonials from '../components/Testimonials';
import CTASection from '../components/CTASection';
import SEO, { webPageSchema } from '../components/SEO';
import { BRAND_NAME } from '../utils/brand';

// /testimonials — dedicated SEO page for "medical weight loss reviews malaysia".
// Reuses the shared Testimonials component so quotes stay in a single source.
export default function TestimonialsPage() {
  return (
    <>
      <SEO jsonLd={webPageSchema(
        '/testimonials',
        'Patient Experiences & Testimonials | Medical Weight Loss | MyDr.Ai',
        'Real journeys to metabolic health with MyDr.Ai — patient experiences from Malaysians on the doctor-led, AI-assisted weight management programme.'
      )} />

      <PageHero
        eyebrow="Patient experiences"
        title="Patient Experiences: Real Journeys to Metabolic Health"
        subtitle={`How Malaysians describe their experience with ${BRAND_NAME}'s doctor-led, AI-assisted medical weight management.`}
      />

      <Testimonials />
      <CTASection />
    </>
  );
}
